import React, { useState, useRef } from "react";
import classnames from "classnames";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import "./DateRange.scss";

import { Calendar } from "react-date-range";

import ru from "date-fns/locale/ru";

import moment from "moment";

import { useOnClickOutside } from "./outside";

function renderLabel(date) {
  return moment(date).format("YYYY-MM-DD");
}

const DateSingle = ({ children, date, onChange, className }) => {
  const ref = useRef(null);
  const [open, setOpen] = useState(false);
  const toggleOpen = () => setOpen(prev => !prev);

  const handleChange = date => {
    onChange(date);
    setOpen(false);
  };

  useOnClickOutside(ref, () => setOpen(false));

  return (
    <div className={classnames("eq-date", className)} ref={ref}>
      <div
        className={classnames("eq-date__control", {
          "eq-date__control-custom": children
        })}
        onClick={toggleOpen}
      >
        {children ? (
          children
        ) : (
          <React.Fragment>
            <i className="eq-date__icon" />
            {renderLabel(date)}
          </React.Fragment>
        )}
      </div>
      {open && (
        <div className="eq-date__calendar">
          <Calendar date={date} onChange={handleChange} />
        </div>
      )}
    </div>
  );
};

export default DateSingle;
